<template>
    <div class="content-font">

        <div class="bg-white"
             style="width:100%;margin:auto;padding:25px">
            <div class="font-gold font-title uppercase" style="margin-bottom: 20px;font-size: larger">
                Make an Enquiry
            </div>
            <form id="enquery-form" onsubmit="return false;" style="width:100%" >

                <input type="text" id="name" name="name" placeholder="Name*" required class="content-font">
                <div style="height:20px" class="flex-center error-msg">{{nameErr}}</div>

                <input type="email" id="email" name="email" placeholder="Email*" required class="content-font">
                <div style="height:20px" class="flex-center error-msg">{{emailErr}}</div>

                <input type="text" id="phone" name="phone" placeholder="Phone*" required class="content-font"
                       minlength="8">
                <div style="height:20px" class="flex-center error-msg">{{phoneErr}}</div>

                <input type="text" id="postcode" name="postcode" placeholder="Postcode*" class="content-font"
                       required digits="true" minlength="4"
                       maxlength="4">
                <div style="height:20px" class="flex-center error-msg">{{postcodeErr}}</div>

                <textarea id="message" class="content-font" placeholder="Message"></textarea>


                <div style="width:100%;display:inline-block;text-align: right;margin-top:20px">
                    <button id="submit">Submit</button>
                </div>

            </form>
        </div>
    </div>
</template>

<script>
	export default {
		name: "ContactForm",
		data() {
			return {
				name: null,
				nameErr: null,
				phone: null,
				phoneErr: null,
				email: null,
				emailErr: null,
				postcode: null,
				postcodeErr: null,
				message: null
			}
		},
		computed: {
			small() {
				return this.$mq === 'sm';
			}
		}
	}
</script>

<style scoped>
    div {
        box-sizing: border-box;
    }

    .error-msg {
        color: #E57C7C;
    }

    input,
    textarea {
        outline: none;
        border: none;
        border-bottom: 1px solid #bbbbbb;
        /*font-size: 1.2em;*/
        /*height: 40px;*/
        padding: 5px;
        /*font-family: Poppins, sans-serif;*/
        background: none;
        /* margin-bottom: 5vh; */
        transition: all 1s;
        display: block;
        margin: auto;
        color: #999999;
        font-size: larger;
        width: 100%;
        box-sizing: border-box;

    }

    textarea {
        height: 100px;
        /* min-height: 100px; */
    }

    button {
        width: 30%;
        /* max-width: 400px; */
        min-width: 100px;
        height: 3vh;
        min-height: 40px;
        background-color: #777777;
        border: none;
        transition: all 1s;
        color: #ffffff;
    }

    button:hover {
        background-color: #B79939;
    }

    input:focus,
    textarea:focus {
        border-bottom: 1px solid #B79939;
        color: #B79939;
    }

    .error {
        color: #E57C7C;
        display: block;
    }

    .content-width {
        width: 100%;
        max-width: 600px;
    }

    .content-wrapper {
        /* border: 1px red solid; */
        /* height: 10vh; */
        /* padding-bottom: 1.5vh; */
        /*height: 8vh;*/
        /*min-height: 80px;*/
    }

    .error-wrapper {
        height: 1.5vh;
        max-height: 100px;
    }

    input:focus::-webkit-input-placeholder,
    textarea:focus::-webkit-input-placeholder {
        opacity: .5;
        color: #B79939;
    }

    /* Firefox < 19 */

    input:focus:-moz-placeholder,
    textarea:focus:-moz-placeholder {
        opacity: .5;
        color: #B79939;
    }

    /* Firefox > 19 */

    input:focus::-moz-placeholder,
    textarea:focus::-moz-placeholder {
        opacity: .5;
        color: #B79939;
    }

    /* Internet Explorer 10 */

    input:focus:-ms-input-placeholder,
    textarea:focus:-ms-input-placeholder {
        opacity: .5;
        color: #B79939;
    }

</style>